import { render, staticRenderFns } from "./InternetPlansTableItem.vue?vue&type=template&id=ef6fcd58&scoped=true&"
import script from "./InternetPlansTableItem.vue?vue&type=script&lang=js&"
export * from "./InternetPlansTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6fcd58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
